export const generateBlockId = (): string =>
  Math.random().toString(36).substring(2, 10);

export const blockIdAttribute = {
  default: () => generateBlockId(),
  parseHTML: (element: HTMLElement) => element.getAttribute('data-block-id'),
  renderHTML: (attributes: { blockId: string | null }) =>
    attributes.blockId ? { 'data-block-id': attributes.blockId } : {},
};
